import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Ring.css";

const Ring = () => {
  const navigate = useNavigate();
  const [rings, setRings] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const redirectToProductPage = (rings) => {
    const imagesByColor = [
      { color: "gold", images: rings?.images?.gold || [] },
      { color: "roseGold", images: rings?.images?.roseGold || [] },
      { color: "silver", images: rings?.images?.silver || [] },
    ];

    navigate("/product", {
      state: {
        imagesByColor,
        productId: rings.productId,
        name: rings.name,
        weight: rings.weight,
        price10k: rings.prices.tenK,
        price14k: rings.prices.fourteenK,
        price18k: rings.prices.eighteenK,
        discountedPrice10k: rings.discountedPrice.tenK,
        discountedPrice14k: rings.discountedPrice.fourteenK,
        discountedPrice18k: rings.discountedPrice.eighteenK,
        availableKarats: rings.availableKarats,
        availableStones: rings.availableStones,
        description: rings.description,
        diamondColor: rings.diamondColor,
        numberOfDiamond: rings.numberOfDiamond,
        diamondCutGrade: rings.diamondCutGrade,
        diamondShape: rings.diamondShape,
        diamondType: rings.diamondType,
        sideDiamondColor: rings.sideDiamondColor,
        numberOfSideDiamond: rings.numberOfSideDiamond,
        sideDiamondShape: rings.sideDiamondShape,
        sideDiamondCutGrade: rings.sideDiamondCutGrade,
        sideDiamondType: rings.sideDiamondType,
        stonePieces: rings.stonePieces,
        stoneColor: rings.stoneColor,
        stoneType: rings.stoneType,
        stoneWeight: rings.stoneWeight,
        stoneShape: rings.stoneShape,
      },
    });   
  };
 
  useEffect(() => {
    const fetchRings = async () => {
      try {
        const response = await axios.get("https://backend.rubiajewels.com/api/products?category=rings");

        const ringsWithColor = response.data.map((rings) => {
          const availableColors = (rings.availableColors || []).filter(
            (color) => rings.images?.[color]?.length > 0
          );

          const defaultColor =
            availableColors.length > 0 ? availableColors[0] : "silver";

          return {
            ...rings,
            currentColor: rings.currentColor || defaultColor,
            price10k: rings.prices.tenK,
            price14k: rings.prices.fourteenK,
            price18k: rings.prices.eighteenK,
            discountedPrice10k: rings.discountedPrice.tenK,
            discountedPrice14k: rings.discountedPrice.fourteenK,
            discountedPrice18k: rings.discountedPrice.eighteenK,
          };
        });

        setRings(ringsWithColor);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchRings();
  }, []);

  const changeColor = (id, color) => {
    setRings((prevRings) =>
      prevRings.map((rings) =>
        rings._id === id ? { ...rings, currentColor: color } : rings
      )
    );
  };

  const addToWishlist = async (product) => {
    try {
      const response = await fetch("https://backend.rubiajewels.com/api/wishlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ productId: product._id }),
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.message);
        return;
      }
 
      setWishlist((prevWishlist) => {
        const updatedWishlist = [...prevWishlist, { productId: product._id }]; 
        localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
        return updatedWishlist;
      });
      alert(`Product added to your wishlist!`);
    } catch (error) {
      console.error("Error adding to wishlist:", error);
    }
  };

  useEffect(() => {
    const fetchWishlist = async () => {
      try { 
        const storedWishlist = localStorage.getItem("wishlist");
        if (storedWishlist) {
          setWishlist(JSON.parse(storedWishlist)); 
        } else { 
          const response = await fetch("https://backend.rubiajewels.com/api/wishlist", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });

          if (!response.ok) {
            throw new Error("Failed to fetch wishlist");
          }

          const data = await response.json();
          setWishlist(data); 
          localStorage.setItem("wishlist", JSON.stringify(data));
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };

    fetchWishlist();
  }, []);

  return (
    <>
      <div className="ring-banner-container"></div>
      <div className="trending-heading">
        <h1>Rings</h1>
        <hr className="ring-hr" />
      </div>

      <div className="trending-container">
        {rings.map((rings) => {
          const imagePath = rings.images?.[rings.currentColor]?.[0]
            ? rings.images[rings.currentColor][0].replace(/\\/g, "/")
            : "default-image.jpg";

          const availableColorButtons = (rings.availableColors || []).filter(
            (color) => rings.images?.[color]?.length > 0
          );

          return (
            <div key={rings._id} className="trending-card">
              <div className="badges">
                <span>Sale</span>
                <span>Ships Quickly</span>
                <button
                  className="wishlist-button"
                  onClick={() => addToWishlist(rings)}
                >
                  <i
                    className={`fa-heart ${
                      wishlist.some((item) => item.productId === rings._id)
                        ? "fa-solid"
                        : "fa-regular"
                    }`}
                  ></i>
                </button>
              </div>
              <div className="ring-image-container">
                <img
                  src={`https://backend.rubiajewels.com/${imagePath}`}  
                  alt={rings.name}
                  className="trending-image"
                  onMouseOver={(e) => {
                    if (rings.images?.hover) {
                      e.currentTarget.src = `https://backend.rubiajewels.com/${rings.images.hover}`;
                    }
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.src = `https://backend.rubiajewels.com/${imagePath}`;
                  }}
                  onClick={() => redirectToProductPage(rings)}
                />
              </div>
              <h3 className="trending-h3">{rings.name}</h3>
              {availableColorButtons.length > 0 && (
                <div className="color-buttons">
                  {availableColorButtons.includes("gold") && (
                    <button
                      onClick={() => changeColor(rings._id, "gold")}
                      className={`gold-button ${
                        rings.currentColor === "gold" ? "active" : ""
                      }`}
                    ></button>
                  )}
                  {availableColorButtons.includes("roseGold") && (
                    <button
                      onClick={() => changeColor(rings._id, "roseGold")}
                      className={`roseGold-button ${
                        rings.currentColor === "roseGold" ? "active" : ""
                      }`}
                    ></button>
                  )}
                  {availableColorButtons.includes("silver") && (
                    <button
                      onClick={() => changeColor(rings._id, "silver")}
                      className={`silver-button ${
                        rings.currentColor === "silver" ? "active" : ""
                      }`}
                    ></button>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Ring;